import { useEffect, useState } from 'react'

import {
  removeUserNoAccessRoleEventListener,
  resetViewAsRolesEventListener
} from '@space-events/viewAsRoles'

import { RoleType } from '@space-shell/core/store'
import { DEFAULT_ROLE_TYPE, useViewAsStore } from '@space-shell/core/store'
import { useParams } from 'react-router-dom'

import { ROLES_NOT_ALLOWED_IN_PRODUCT, ROLE_TYPES } from './constants'

const useFilterRoles = () => {
  const { productId } = useParams<{ productId: string }>()
  const { role } = useViewAsStore()
  const [items, setItems] = useState<RoleType[]>(ROLE_TYPES)

  useEffect(() => {
    const filterUserNoAccessRole = () => {
      setItems((prevState) => {
        return prevState.filter((item) => item !== RoleType.UserNoAccess)
      })

      useViewAsStore.setState({ role: DEFAULT_ROLE_TYPE })
    }

    const cleanFilter = () => {
      setItems(ROLE_TYPES)
    }

    removeUserNoAccessRoleEventListener(filterUserNoAccessRole)
    resetViewAsRolesEventListener(cleanFilter)
  }, [])

  useEffect(() => {
    if (productId) {
      setItems((prevState) => {
        return prevState.filter((item) => !ROLES_NOT_ALLOWED_IN_PRODUCT.includes(item))
      })

      if (ROLES_NOT_ALLOWED_IN_PRODUCT.includes(role)) {
        useViewAsStore.setState({ role: DEFAULT_ROLE_TYPE })
      }
    }
  }, [productId, role])

  return { items }
}

export { useFilterRoles }
